import { render, staticRenderFns } from "./LanguageSelectDashboardItem.vue?vue&type=template&id=89e9872e&scoped=true"
import script from "./LanguageSelectDashboardItem.vue?vue&type=script&lang=js"
export * from "./LanguageSelectDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelectDashboardItem.vue?vue&type=style&index=0&id=89e9872e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e9872e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89e9872e')) {
      api.createRecord('89e9872e', component.options)
    } else {
      api.reload('89e9872e', component.options)
    }
    module.hot.accept("./LanguageSelectDashboardItem.vue?vue&type=template&id=89e9872e&scoped=true", function () {
      api.rerender('89e9872e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/LanguageSelectDashboardItem.vue"
export default component.exports